module.exports = __webpack_public_path__ + "img/CellCycle-CRC_GSE225857.ff461bb6.png";